import { render, staticRenderFns } from "./travelRequests.vue?vue&type=template&id=c3588c08&"
import script from "./travelRequests.vue?vue&type=script&lang=js&"
export * from "./travelRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports